import { render } from "./company-tab.vue?vue&type=template&id=543eb81f&scoped=true&ts=true"
import script from "./company-tab.vue?vue&type=script&lang=ts"
export * from "./company-tab.vue?vue&type=script&lang=ts"

import "./company-tab.vue?vue&type=style&index=0&id=543eb81f&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543eb81f"]])

export default __exports__